import Home from "./pages/Home/Index";

const routes = [{ path: "/", component: <Home /> }];

export default routes;
